import { render, staticRenderFns } from "./Alcafozense.vue?vue&type=template&id=00483335&scoped=true&"
import script from "./Alcafozense.vue?vue&type=script&lang=js&"
export * from "./Alcafozense.vue?vue&type=script&lang=js&"
import style0 from "./Alcafozense.vue?vue&type=style&index=0&id=00483335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00483335",
  null
  
)

export default component.exports